import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-514931c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen-wrapper" }
const _hoisted_2 = { class: "is-flex is-align-items-center is-justify-content-space-between mb-5" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = { class: "has-text-weight-bold text-sm" }
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = { class: "has-text-weight-bold text-sm" }
const _hoisted_9 = ["data-testid", "onClick"]
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "tag is-small" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag is-small" }, "∞", -1 /* HOISTED */))

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import IconButton from '@/popup/components/shared/IconButton.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import { GlobalDatabase } from '@/popup/storage/Database'
import Tooltip from '@/popup/components/shared/Tooltip/Tooltip.vue'
import { RelayServiceDBSchema } from '@/shared/Database/UPSettings/models'


export default /*#__PURE__*/_defineComponent({
  __name: 'ListRelayer',
  setup(__props) {

const router = useRouter()
const allRelayers = ref<RelayServiceDBSchema[]>([])
const onMountedRun = ref(false)

onMounted(async () => {
  allRelayers.value = await GlobalDatabase.getAllRelayers()
  onMountedRun.value = true
})

const internalRelayers = computed(() =>
  allRelayers.value.filter(relayer => !relayer.isCustom)
)

const customRelayers = computed(() =>
  allRelayers.value.filter(relayer => relayer.isCustom)
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('settings.relayer.header')), 1 /* TEXT */),
      _createVNode(IconButton, {
        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/settings')))
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["loader", { loaded: onMountedRun.value }])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.$t('relayers.internal.title')), 1 /* TEXT */),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(internalRelayers.value, (relayer) => {
          return (_openBlock(), _createElementBlock("button", {
            key: relayer.id,
            class: "button is-fullwidth is-secondary is-justify-content-start mb-2",
            disabled: "",
            "data-testid": relayer.id
          }, _toDisplayString(relayer.name), 9 /* TEXT, PROPS */, _hoisted_6))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.$t('relayers.custom.title')), 1 /* TEXT */),
        _createElementVNode("button", {
          class: "button is-fullwidth add-relayer is-flex is-align-items-center mb-2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (
            _unref(router).push({
              name: 'addRelayer',
            })
          ))
        }, [
          _createVNode(SvgIcon, {
            name: "add",
            fill: "--neutral-60",
            class: "icon mr-2"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('relayers.custom.add_relayer')), 1 /* TEXT */)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customRelayers.value, (relayer) => {
          return (_openBlock(), _createElementBlock("button", {
            key: relayer.id,
            class: "button is-secondary is-fullwidth is-justify-content-space-between mb-2",
            "data-testid": relayer.id,
            onClick: _withModifiers(($event: any) => (
            _unref(router).push({
              name: 'editRelayer',
              params: { relayerId: relayer.id },
            })
          ), ["stop"])
          }, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(relayer.name), 1 /* TEXT */),
            (relayer.chainIds.length > 0)
              ? (_openBlock(), _createBlock(Tooltip, {
                  key: 0,
                  value: 
              _ctx.$t('relayers.custom.used_by_number', {
                count: relayer.chainIds.length,
              })
            ,
                  "offset-distance": "5",
                  placement: "left"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(relayer.chainIds.length), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
              : (_openBlock(), _createBlock(Tooltip, {
                  key: 1,
                  value: _ctx.$t('relayers.custom.used_by_all'),
                  "offset-distance": "5",
                  placement: "left"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value"]))
          ], 8 /* PROPS */, _hoisted_9))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ], 2 /* CLASS */)
  ]))
}
}

})